import { CompanyHomeThemeSizeConfig } from './types';

const large: CompanyHomeThemeSizeConfig = {
  companyHome: {},
};

export default large;
